import { transitionBiddingSpotApprovalState } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'

import { spotApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * スポット入札 承認ステータス遷移 mutation hook (楽観ロック使用)。
 * action: REQUEST / APPROVE / REJECT / CANCEL / SUBMIT を指定。
 * spot では WITHDRAW は InvalidArgument になるため UI 上は非表示にする。
 */
export function useTransitionBiddingSpotApprovalState(): InvalidatingMutationResultFor<
  typeof transitionBiddingSpotApprovalState
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      transitionBiddingSpotApprovalState,
      spotApprovalRequestInvalidationKeys,
    ),
  )
}
